import React from 'react';

type CardPadding = 'sm' | 'base' | 'lg';

interface CardProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  padding?: CardPadding;
  className?: string;
}

const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  children,
  padding = 'base',
  className = '',
}) => {
  const paddings = {
    sm: 'p-4',
    base: 'p-6',
    lg: 'p-8',
  };
  
  return (
    <div
      className={`bg-white rounded-lg border border-stone-200 shadow-sm ${paddings[padding]} ${className}`}
    >
      {(title || subtitle) && (
        <div className="mb-4">
          {title && (
            <h3 className="font-sans text-lg font-medium text-black">
              {title}
            </h3>
          )}
          {subtitle && (
            <p className="font-sans text-sm text-grey-600 mt-1">
              {subtitle}
            </p>
          )}
        </div>
      )}
      <div>{children}</div>
    </div>
  );
};

export default Card; 